import { combineReducers } from "@reduxjs/toolkit";
import palletEdit from "./slices/palletEdit.feature";
import palletCache from "./slices/palletCache.feature";
import auth from "./slices/auth.feature";
import activity from "./slices/activity.feature";
import workorderItems from "./slices/workorderItems.feature";
import consumptionDetails from "./slices/consumptionDetails.feature";
import modalPalletsFeature2 from "./slices/modalPallets2.feature";
import labelling from "./slices/labelling.feature";
import workorderManagement from "./slices/workorderManagement.feature";
import printHistoryFooters from "./slices/printHistoryFooters.feature";
import reprintFeature from "./slices/reprint.feature";
import adminFeature from "./slices/admin.feature";
import schedulesFeature from "./slices/schedules.feature";

const rootReducer = combineReducers({
    palletCache: palletCache,
    palletEdit: palletEdit,
    auth: auth,
    activity: activity,
    workorderItems: workorderItems,
    consumptionDetails: consumptionDetails,
    labelling: labelling,
    modalPallets2: modalPalletsFeature2,
    workorderManagement: workorderManagement,
    printHistoryFooters: printHistoryFooters,
    admin: adminFeature,
    schedules: schedulesFeature,
    reprint: reprintFeature
});

export default rootReducer;
